import TokenService from 'services/token/Token';
import LoginView from 'modules/authentication/Login';

export function RequireLoginView({ children }) {
    const authToken = TokenService.getData();
    const canAccess = Boolean(authToken);

    if (!canAccess) {
        return <LoginView />;
    }

    return children;
}
